import mixin from './mixin'
import plan_mixin from './plan_mixin'
import target_mixin from './target_mixin'
import { setSession, getSession } from '@/common/js/api'
import { isArray, isEmpty, timeout, pullKeys, getByteLen, deepCopy } from '@/common/js/utils'

import SelectButler from '@/components/select/select-butler.vue'
import SelectMonitor from '@/components/select/select-monitor.vue'
import SelectTargeter from '@/components/select/select-target.vue'
import InputRange from '@/components/input/input-number-range'
import Landpage from '@/components/landpage/landpage.vue'
import Targeting from './components/targeting'
import Converter from './components/converter'
import TransFeed from './components/transFeed.vue'

import { getCaoHuaGames, getCaoHuaAgent } from '@/api/common.model'
import { getLogidUrl } from '@/api/manage.model'

export default {
  name: 'bdLocalPlan',
  mixins: [mixin, plan_mixin, target_mixin],
  components: { SelectButler, SelectMonitor, SelectTargeter, InputRange, Landpage, Targeting, Converter, TransFeed },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    platformGameData() {
      return this.gameData.filter((ret) => ret.ch_platform_id === this.plan.ch_platform_id)
    },
    curTarget() {
      const { targetingParam } = this.targetPlan.filter((ret) => ret.check).pop() || {}
      return targetingParam || {}
    },
    curName() {
      const { targetingName } = this.targetPlan.filter((ret) => ret.check).pop() || {}
      return targetingName || ''
    },
    isAndroid() {
      return this.plan.ch_platform_id === 1
    },
    isIOS() {
      return this.plan.ch_platform_id === 2
    },
    isMiniProgram() {
      return this.plan.ch_platform_id === 3
    },
    isUnion() {
      return this.plan.union === 'CUSTOM'
    },
    isLink() {
      return this.plan.landing_type === 'LINK'
    }
  },
  data() {
    return {
      miniProgramTransList: [], // 小程序转化列表
      plan: {
        plan_name: '',
        ch_platform_id: 1, // 游戏类型
        game_id: '',
        package: '',
        game_address: '',
        agent: 'NOAGENT', // 是否代投
        proxy_account_id: undefined,
        page_addr: '', // 落地页
        land_page_id: undefined, // 落地页ID
        managePlan: [], // 计划管家
        monitorPlan: [], // 自动化规则
        monitor_template_id: undefined,
        plan_auto_task_id: undefined,
        callback_switch: 0, // 回调开关，默认关闭
        callback_settings: ['callbackTypeActive', 'callbackTypeRegist', 'callbackTypeRecharge', 'callbackTypeMoney'], // 回调类型

        union: 'NONE', // 流量范围
        autoOpt: { autoOptStrategies: [] },

        bidtype: 3, // 投放目标
        payMode: 2, // 付款方式
        transType: 4, // 转化类型
        transTypeAttribute: false, // 转化类型：付费 是否勾选优化付费次数
        innerUrl: true, // 系统推荐落地页
        lpUrl: '', // 推广URL
        bid: '',
        ocpcLevel: 2,
        bid_range: 0, // 随机出价
        bid_num_range: ['', ''],
        ocpcBid: '', // 第二阶段出价

        appTransIdByAccount: {}, // 小程序转化列表  {  [accountId]: {} }

        optimizeDeepTrans: '',
        useRoi: '',
        deepTransType: 26,
        deep_bid_mode: false,
        deep_bid_range: 0, // 随机深度出价
        deep_deepbid_num_range: ['', ''],
        deepOcpcBid: ''
      }
    }
  },
  methods: {
    getData() {
      const data = getSession('plan_params') || {}
      if (data && Object.keys(data).length > 0 && this.editState) {
        Object.keys(data).forEach((ret) => {
          this.$set(this, ret, data[ret])
        })
      }
      this.$nextTick(() => {
        this.setTargeter(this.targetPlan.length - 1)
        this.$Spin.hide()

        // 重新获取小程序的转化列表
        if (this.isLink && this.isMiniProgram) {
          this.getConvertByAccount(this.adAccount)
        }
      })
    },
    // 自动获焦
    focuslpUrl(val) {
      if (!val && this.$refs.lpurl) {
        timeout(300).then(() => {
          this.$refs.lpurl[0].focus()
        })
      }
    },
    changeTransType(val) {
      if (this.plan.deep_bid_mode) {
        this.$set(this.plan, 'useRoi', val === 26 ? 'useRoi' : '')
        this.$set(this.plan, 'optimizeDeepTrans', val === 4 ? 'optimizeDeepTrans' : '')
      }
    },
    // 切换随机出价
    changeBidRange(val) {
      if (val) {
        this.$set(this.plan, 'bid_num_range', ['', ''])
        this.$set(this.plan, 'ocpcBid', '')
      }
    },
    changeDeepCpabidRange(val) {
      if (val) {
        this.$set(this.plan, 'deep_deepbid_num_range', ['', ''])
        this.$set(this.plan, 'deepOcpcBid', '')
      }
    },
    // 深度出价
    changDeepBid(val) {
      if (val) {
        if (this.plan.transType === 26) this.$set(this.plan, 'useRoi', 'useRoi')
        else this.$set(this.plan, 'optimizeDeepTrans', 'optimizeDeepTrans')

        // 20221130 按照付费次数优化不允许叠加选择ROI优化
        // 打开深度转化出价开关时，取消勾选优化付费次数
        this.$set(this.plan, 'transTypeAttribute', false)
      } else {
        this.$set(this.plan, 'optimizeDeepTrans', '')
        this.$set(this.plan, 'useRoi', '')
      }
      this.$set(this.plan, 'deep_bid_range', 0)
      this.$set(this.plan, 'deep_deepbid_num_range', ['', ''])
      this.$set(this.plan, 'deepOcpcBid', '')
      this.$set(this.plan, 'roiRatio', '')
    },
    changePayMode(val) {
      this.$set(this.plan, 'isSkipStageOne', val === 1 ? false : undefined)
      this.changeSkipStage()
    },
    changeSkipStage() {
      this.$set(this.plan, 'bid', '')
    },
    preloadData() {
      let param
      const { promoted_object_type, budget } = getSession('campaign') || {}
      this.$set(this.plan, 'budget', budget)
      if (promoted_object_type > 1) {
        // 推广应用
        this.$set(this.plan, 'landing_type', 'APP')
        this.$set(this.plan, 'ch_platform_id', promoted_object_type === 2 ? promoted_object_type : 1)
        param = { filter: 1, mediaId: this.media }
      } else {
        this.$set(this.plan, 'landing_type', 'LINK')
      }
      // 请求开始
      this.$Spin.show()
      Promise.all([getCaoHuaGames(param), getCaoHuaAgent()])
        .then((data) => {
          const [gameData, agentData] = data
          isArray(gameData) && (this.gameData = gameData)
          isArray(agentData) && (this.agentData = agentData)
          if (this.editState) this.getData()
          else this.appendTargeter() // 默认增加一个定向
        })
        .catch(() => {
          throw new Error('请求接口错误')
        })
    },
    valid() {
      const rules = [
        {
          name: 'plan/plan_name',
          require: true,
          min: 3,
          max: 90,
          desc: '计划名称'
        },
        {
          name: 'plan/game_id',
          require: true,
          min: 1,
          desc: '投放游戏'
        },
        {
          name: 'plan/proxy_account_id',
          require: true,
          relyon: 'plan/agent',
          relyvalue: 'AGENT',
          min: 1,
          desc: '代投账号'
        },
        {
          name: 'plan/page_addr',
          require: true,
          relyon: 'plan/landing_type',
          relyvalue: 'LINK',
          min: 1,
          desc: '落地页地址'
        },
        // {
        //   name: 'plan/bid',
        //   require: true,
        //   relyon: 'plan/isSkipStageOne',
        //   relyvalue: false,
        //   min: 0.3,
        //   max: 999.99,
        //   desc: '点击出价'
        // },
        {
          name: 'plan/ocpcBid',
          require: true,
          relyon: 'plan/bid_range',
          relyvalue: 0,
          min: 0.3,
          max: 99999.99,
          desc: '目标转化出价'
        },
        {
          name: 'plan/bid_num_range',
          require: true,
          relyon: 'plan/bid_range',
          relyvalue: 1,
          min: 2,
          desc: '目标转化出价随机金额'
        },
        {
          name: 'plan/roiRatio',
          require: true,
          relyon: 'plan/useRoi',
          relyvalue: 'useRoi',
          min: 0.01,
          max: 100,
          desc: 'ROI系数'
        }
      ]
      return this.invalid(rules)
    },
    customValid(params) {
      const err = []
      const {
        bid_range,
        ocpcBid,
        bid_num_range,
        budget,
        deep_bid_mode,
        optimizeDeepTrans,
        deep_bid_range,
        deep_deepbid_num_range,
        deepOcpcBid,
        appTransIdByAccount
      } = params
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = params.plan_name.match(regexp)
      let plan_name_length = getByteLen(params.plan_name)

      if (isArray(values)) {
        values.forEach((ret) => {
          ret === '{定向包名}' && (plan_name_length += 11)
          ret === '{创意组名}' && (plan_name_length += 11)
        })
      }

      console.log('budget ddd output: ', budget)

      if (plan_name_length > 90) err.push({ feild: '计划名称', msg: `加入动态词后的长度${plan_name_length}，超过了90个字符` })
      if (budget && ocpcBid && ocpcBid > budget) err.push({ feild: '目标转化出价', msg: `出价不能大于预算值 ${budget}` })

      if (bid_range) {
        // 随机出价
        const [min, max] = bid_num_range
        if (isEmpty(min) || isEmpty(max)) err.push({ feild: '目标转化出价', msg: '随机值不能为空' })
        else if (budget && Math.max(min, max) > budget) err.push({ feild: '目标转化出价', msg: `随机值不能大于预算值 ${budget}` })
      }
      if (deep_bid_mode && optimizeDeepTrans) {
        // 深度优化转化
        if (deep_bid_range) {
          const [min, max] = deep_deepbid_num_range
          if (isEmpty(min) || isEmpty(max)) err.push({ feild: '深度转化出价', msg: '随机值不能为空' })
          else if (ocpcBid && Math.min(min, max) <= ocpcBid) err.push({ feild: '深度转化出价', msg: '随机值应大于目标转化出价' })
        } else {
          if (isEmpty(deepOcpcBid)) err.push({ feild: '深度转化出价', msg: '出价不能为空' })
          else if (deepOcpcBid < 0.4 || deepOcpcBid >= 100000) err.push({ feild: '深度转化出价', msg: '出价范围：0.4~99999.99（元）' })
          else if (ocpcBid && ocpcBid >= deepOcpcBid) err.push({ feild: '深度转化出价', msg: '深度转化出价应大于目标转化出价' })
        }
      }

      if (this.isLink && this.isMiniProgram) {
        const accounts = Object.keys(appTransIdByAccount)
        // 是否每个账号都选择了转化
        const unSelectedItem = this.accounts.filter((ac) => !accounts.includes(String(ac.id)))
        if (unSelectedItem.length) {
          const [ac] = unSelectedItem
          err.push({ feild: '转化名称', msg: `请选择账号${ac.name}的转化名称` })
        }
      }

      // 定向名重复
      if (this.check === 'error') err.push({ feild: '计划名称', msg: '已存在，请更换成可用名称' })

      // 定向名称过长
      const moreTargetName = this.targetPlan.some((ret) => {
        return isEmpty(ret.targetingName) || getByteLen(ret.targetingName) > 20
      })
      const moreAppLen = this.targetPlan.some((ret) => {
        const { app, mult_app, appType } = ret.targetingParam
        const invaid_app = isArray(app) && app.length
        const invaid_mult = isArray(mult_app) && mult_app.length
        return appType !== 'all' && !invaid_app && !invaid_mult
      })
      moreTargetName && err.push({ feild: '定向包名称', msg: '不符合规则1-20个字符，请逐个定向检查' })
      moreAppLen && err.push({ feild: '定向参数', msg: 'APP定向未选中值时请选择“不限”，请逐个定向检查' })

      return err
    },
    adjustment() {
      const params = deepCopy(this.plan)
      params.plan_auto_task_id = params.monitorPlan.map((ret) => ret.id).join(',')
      params.monitor_template_id = params.managePlan.map((ret) => ret.id).join(',')

      if (params.deep_bid_mode) {
        params.useRoi = Boolean(params.useRoi)
        params.optimizeDeepTrans = Boolean(params.optimizeDeepTrans)
      }
      return params
    },
    async submitToNext() {
      const params = this.adjustment()
      if (!params) return

      // 验证模板
      this.formErr = false
      this.errRes = [...this.valid(), ...this.customValid(params)] // 表单验证

      if (this.errRes.length) {
        this.formErr = true
        return
      }

      // 小程序平台校验配置信息
      if (params.ch_platform_id === 3) {
        try {
          for (const i in this.accounts) {
            const acc = this.accounts[i]
            const { logidUrl, token } = await getLogidUrl({ adAccountId: acc.id, gameId: params.game_id })
            if (!logidUrl || !token) {
              throw new Error(acc.id)
            }
          }
        } catch (e) {
          return this.$Message.warning(
            `账号：${e.message}，未在【天工开物】【投放】【百度小游戏归因配置】配置小程序上报token和账号配置落地页`
          )
        }
      }

      const inner_plan_params = pullKeys(
        [
          'plan_name',
          'ch_platform_id',
          'game_id',
          'agent',
          'proxy_account_id',
          'landing_type',
          'land_page_id',
          'page_addr',
          'monitor_template_id',
          'plan_auto_task_id',
          'callback_switch',
          'callback_settings',
          'managePlan'
        ],
        params
      )

      // 6.10下线 'autoOpt',
      // 20221130 下线 ocpc ocpm 付费模式payMode ，点击出价bid, 是否跳过数据积累开关isSkipStageOne
      const outer_plan_params = pullKeys(
        [
          'union',
          'bidtype',
          // 'payMode',
          'transType',
          'transTypeAttribute',
          'innerUrl',
          'lpUrl',
          'ocpcLevel',
          // 'isSkipStageOne',
          // 'bid',
          'bid_range',
          'bid_num_range',
          'ocpcBid',
          'deep_bid_mode',
          'optimizeDeepTrans',
          'deepTransType',
          'deep_bid_range',
          'deep_deepbid_num_range',
          'deepOcpcBid',
          'roiRatio',
          'useRoi'
        ],
        params
      )

      const targetings = this.checkTargeter()
      // 保存并修改
      setSession('plan_params', this.$data)
      setSession('inner_plan_params', inner_plan_params)
      setSession('outer_plan_params', outer_plan_params)
      setSession('targetings', targetings)

      if (this.isLink && this.isMiniProgram) {
        const convertParams = []
        for (const i in this.plan.appTransIdByAccount) {
          const item = this.plan.appTransIdByAccount[i]
          item.accountId = Number(i)
          convertParams.push(item)
        }

        setSession('convert_params', convertParams)
        this.jump()
      } else {
        this.convertModel = true
      }

      // this.jump()
    },
    jump() {
      const { creativeData } = getSession('idea_params') || {}
      // 路由跳转
      if (this.editState && isArray(creativeData) && creativeData.length) {
        this.$router.push({ name: 'baidulocalidea', query: { t: 'edit' } })
      } else this.$router.push({ name: 'baidulocalidea' })
    }
  },
  watch: {
    isAndroid(val) {
      this.$set(this.plan, 'callback_switch', !val ? 1 : 0)
      this.$set(this.plan, 'callback_settings', ['callbackTypeActive', 'callbackTypeRegist', 'callbackTypeRecharge', 'callbackTypeMoney'])
    }
  },
  created() {
    this.preloadData()
  }
}
